module.exports = __webpack_public_path__ + "static/media/layer-3@2x.76c0cb1a.png";